import _defineProperty from "@babel/runtime/helpers/defineProperty";
/** @jsx jsx */
import { components } from '@atlaskit/select';
import { css, jsx } from '@emotion/react';
import React from 'react';
import { SizeableAvatar } from './SizeableAvatar';
import { BORDER_PADDING } from './styles';
import ValueContainerWrapper from './ValueContainerWrapper';
const placeholderIconContainer = css({
  paddingLeft: BORDER_PADDING,
  lineHeight: 0,
  gridArea: '1/1/2/2'
});
const showUserAvatar = (inputValue, value) => value && value.data && inputValue === value.label;
export class SingleValueContainer extends React.Component {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "renderAvatar", () => {
      const {
        hasValue,
        selectProps: {
          appearance,
          isFocused,
          inputValue,
          value,
          placeholderAvatar
        }
      } = this.props;
      if (isFocused || !hasValue) {
        return jsx(SizeableAvatar, {
          appearance: appearance,
          type: placeholderAvatar,
          src: showUserAvatar(inputValue, value) ? value.data.avatarUrl : undefined
        });
      }
      return null;
    });
    _defineProperty(this, "onValueContainerClick", this.props.selectProps.onValueContainerClick);
    _defineProperty(this, "Wrapper", ({
      children
    }) => {
      return this.onValueContainerClick ? jsx("div", {
        css: css({
          flexGrow: 1
        }),
        onMouseDown: this.onValueContainerClick
      }, children) : children;
    });
  }
  render() {
    const {
      children,
      ...valueContainerProps
    } = this.props;
    return jsx(ValueContainerWrapper, {
      isEnabled: this.onValueContainerClick,
      onMouseDown: this.onValueContainerClick
    }, jsx(components.ValueContainer, valueContainerProps, jsx("div", {
      css: placeholderIconContainer
    }, this.renderAvatar()), children));
  }
}